<script>
  import LightBox from '../assets/general/ImageLightBox.svelte';
  import DonateWidget from '../assets/donate/DonationWidget.svelte';
  import { onMount } from 'svelte';

  onMount(() => {
    const gl = document.createElement('script');
    gl.src = 'https://secure.givelively.org/widgets/simple_donation/freedom-writers-foundation.js?show_suggested_amount_buttons=false&show_in_honor_of=false&address_required=false&has_required_custom_question=null';
    document.head.appendChild(gl);
  });
</script>


<main>
  <div class="container">
    <div class="left-column">
      <div class="left-container">
      <h1>You can make a difference.</h1>
      <br><br>
      <p>The Freedom Writers Foundation has impacted over <strong><em>1,000,000 students</em></strong> with its Freedom Writers Methodology. Over 800 trained “Freedom Writer Teachers” in all 50 U.S. States and 20 countries are teaching thousands of students a day with our student-centered, culturally-relevant approach. As they focus on helping their students find success both inside and outside the classroom, these educators are following in the footsteps of Ms. G and the Freedom Writers and changing the world one student at a time.
      <br><br>
      Your donation contributes to our Teacher Training Program, Outreach Program, and Scholarship Program. By pledging your support of this cause, you are making a difference in the lives of teachers and students around the world.
      <br><br>
      Make your secure, tax-deductible donation through our partner GiveLively:</p>
      <br><br>
  <div id="donation">
  <!-- Begin Give Lively Fundraising Widget -->
  <div id="give-lively-widget" class="gl-simple-donation-widget"></div>
  <!-- End Give Lively Fundraising Widget -->
  </div>
      </div>
      <br><br>
      <LightBox 
        imageUrl="../images/backgrounds/ScholarshipOldOffice.jpg"
        imageWidth="100%"
        imageHeight="auto"
        title="Freedom Writers Scholars"
        altText="These Freedom Writers Scholars receive their scholarships at our annual Freedom Writers Scholarship Brunch."
      />
    </div>
    <div class="right-column">
      <LightBox 
        imageUrl="../images/backgrounds/Scholars.jpg"
        imageWidth="100%"
        imageHeight="auto"
        title="2015 Wilson Freedom Writer Scholars"
        altText="Wilson High School (Where the Freedom Writers were founded in Room 203) Freedom Writer Scholars receiving their Freedom Writers Scholarships in 2015."
      />
      <LightBox 
        imageUrl="../images/other/ScholarshipBrunch.jpg"
        imageWidth="100%"
        imageHeight="auto"
        title="Freedom Writers Scholarship Brunch, 2015"
        altText="Wilson High School (Where the Freedom Writers were founded in Room 203) Freedom Writer Scholars receiving their Freedom Writers Scholarships in 2015."
      />
      <LightBox 
        imageUrl="../images/other/TyeAndSueEllen.png"
        imageWidth="100%"
        imageHeight="auto"
        title="Original Freedom Writers Tye & Sue Ellen working with students Freedom Writers Intervention"
        altText="Two of the Original 150 Freedom Writers Tye and Sue Ellen working with students Freedom Writers Youth Engagement Program recreating Room 203."
      />
      <LightBox 
        imageUrl="../images/other/ErinInstitute.png"
        imageWidth="100%"
        imageHeight="auto"
        title="Freedom Writer Foundation FWF Founder Erin Gruwell at Freedom Writers Teacher Institute"
        altText="Future Freedom Writer Teachers adopt and ingest the pedagogy of world renowned educator Erin Gruwell at our professional development training known as the Freedom Writers Teachers Institute."
      />
      <LightBox 
        imageUrl="../images/other/LibraryOfCongress.jpg"
        imageWidth="100%"
        imageHeight="auto"
        title="Freedom Writers Foundation Library of Congress"
        altText="The Freedom Writers Foundation show up to Washington DC to speak to Congress and for the Freedom Writers Diary to be inducted into the Library of Congress."
      />
    </div>
  </div>
</main>

<style>
  h1 {
    font-size: 2rem;
    font-family: 'Oswald', sans-serif;
    font-style: italic;
  }
  p {
    font-size: 1rem;
    font-family: 'Arial';
    line-height: 1.5;
  }
  .container {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 1rem; /* This sets the gap between the grid items */
    align-items: start; /* Aligns items at the start of the container */
    width: 100%;
    padding: 34px 0;
  }

  .left-column {
    /* No need to set width here, it's handled by the grid */
  }

  .left-container {
    padding-right: 7%; /* Adjust padding to give some space between the columns */
  }

  .right-column {
    display: grid;
    gap: 1rem; /* This sets the gap between the Lightbox components */
    padding: 3%;
  }

  /* This media query hides the right column on mobile and lets the left column take full width */
  @media (max-width: 768px) {
    .container {
      display: block; /* Switch back to standard block layout */
    }

    .left-column,
    .right-column {
      width: 100%;
      padding: 0;
    }

    .right-column {
      display: none;
    }

    .left-container {
      padding: 0 7%;
    }
  }

  main {
    margin: 0 7%;
  }
</style>